import { useState, useRef } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import calendar from "../../../icons/webicons/calendar_dark.svg";
import { DateWrapper } from "./styles";
import { Flex } from "../division";

const POPPER_MODIFIERS = {
  flip: { behavior: ["bottom"] },
  preventOverflow: { enabled: false },
  hide: { enabled: false }
};

export default function Datepicker({
  currentDate: currentDateProp, handleChange, name,
  minDate, maxDate, timePicker, fontStyle, disable, placeholder
}) {
  const [currentDate, setCurrentDate] = useState(currentDateProp || "");
  const locale = useRef("en");

  if (window.location.pathname.includes("zh-cn") && locale.current === "en") {
    locale.current = "cn";
    registerLocale("cn", cn);
  }

  const onDatepickerRef = (el) => {
    if (el && el.input) el.input.readOnly = true;
  };

  const handleDateChange = (date) => {
    if (currentDate !== date) {
      setCurrentDate(date);
      handleChange(name, date);
    }
  };

  const dateFormat = window.navigator.language === "en-US" ? "M/d/yyyy" : "dd/MM/yyyy";

  return (
    <DateWrapper data-testid="date-wrapper" fontStyle={String(fontStyle)}>
      <Flex>
        {timePicker ? (
          <DatePicker
            data-testid="date-picker"
            locale={locale.current}
            popperPlacement="bottom"
            popperModifiers={POPPER_MODIFIERS}
            selected={currentDateProp}
            onChange={handleDateChange}
            minDate={minDate}
            maxDate={maxDate}
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            dateFormat={dateFormat}
            ref={onDatepickerRef}
            placeholderText={placeholder}
          />
        ) : (
          <DatePicker
            locale={locale.current}
            popperPlacement="bottom"
            popperModifiers={POPPER_MODIFIERS}
            selected={currentDate}
            onChange={handleDateChange}
            minDate={minDate}
            maxDate={maxDate}
            disabled={disable}
            dateFormat={dateFormat}
            ref={onDatepickerRef}
            placeholderText={placeholder}
          />
        )}
        <img src={calendar} alt="calendar" loading="lazy" />
      </Flex>
    </DateWrapper>
  );
}
